/**
 * Stripe client-side initialization
 *
 * Loads Stripe.js with the publishable key from environment.
 * Uses singleton pattern — safe to call getStripe() multiple times.
 */

import { loadStripe, type Stripe } from '@stripe/stripe-js'

let stripePromise: Promise<Stripe | null> | null = null

export function getStripe(): Promise<Stripe | null> {
  if (!stripePromise) {
    const key = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY
    if (!key) {
      console.warn('[Stripe] VITE_STRIPE_PUBLISHABLE_KEY not set')
      return Promise.resolve(null)
    }
    stripePromise = loadStripe(key)
  }
  return stripePromise
}
